
const EXECUTION_THRESHOLD = 3;

var averageTimePerMethod = new Map();

/**
 * Usage:
 *  * import the decorator method into the class - <i>import { executionMethodTime } from "@goodgamestudios/createjs-utilities";</i>
 *  * add decorator to the wished method - <i>@executionMethodTime</i>
 * @param target
 * @param {string} propertyKey
 * @param {PropertyDescriptor} descriptor
 * @returns {PropertyDescriptor}
 */
function executionMethodTime(target: any, propertyKey: string, descriptor: PropertyDescriptor) {

    if(descriptor === undefined) {
        descriptor = Object.getOwnPropertyDescriptor(target, propertyKey) as PropertyDescriptor;
    }
    var originalMethod = descriptor.value;

    descriptor.value = function () {

        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i - 0] = arguments[_i];
        }

        console.log(`Performance - Method: %c${propertyKey}%c scope:`, "color: blue;", "color: black;");
        let timeStamp = performance.now();
        var result = originalMethod.apply(this, args);
        let endTimeStamp = performance.now() - timeStamp;
        let durationIndicatorColor = endTimeStamp > EXECUTION_THRESHOLD ? "red" : "green" ;

        let averageTimeForMethod = addExecutedMethod(target, propertyKey, endTimeStamp);
        console.log(`Performance - Method %c${propertyKey}%c took - %c${endTimeStamp} %cms [Average time: %c${averageTimeForMethod} %cms]`, "color: blue;", "color: black;", `color: ${durationIndicatorColor};`, "color: black;", `color: ${durationIndicatorColor};`, "color: black;");

        return result;
    };

    return descriptor;
}

/**
 * Usage:
 *  * import the decorator method into the class - <i>import { executionGetterTime } from "@goodgamestudios/createjs-utilities";</i>
 *  * add decorator to the wished getter - <i>@executionGetterTime</i>
 *  <b> The used classes by getter must be imported in advance </b>
 * @param target
 * @param {string} propertyKey
 * @param {PropertyDescriptor} descriptor
 * @returns {PropertyDescriptor}
 */
function executionGetterTime(target: any, propertyKey: string, descriptor: PropertyDescriptor) {

    if(descriptor === undefined) {
        descriptor = Object.getOwnPropertyDescriptor(target, propertyKey) as PropertyDescriptor;
    }
    var get = descriptor.get;

    if (get){
        descriptor.get = function () {
            console.log(`Performance - Getter: %c${propertyKey}%c scope:`, "color: blue;", "color: black;");
            let timeStamp = performance.now();
            var result = get !== undefined? get.apply(this) : undefined;
            let endTimeStamp = performance.now() - timeStamp;
            let durationIndicatorColor = endTimeStamp > EXECUTION_THRESHOLD ? "red" : "green" ;

            let averageTimeForMethod = addExecutedMethod(target, propertyKey, endTimeStamp);
            console.log(`Performance - Getter: %c${propertyKey}%c took - %c${endTimeStamp} %cms [Average time: %c${averageTimeForMethod} %cms]`, "color: blue;", "color: black;", `color: ${durationIndicatorColor};`, "color: black;", `color: ${durationIndicatorColor};`, "color: black;");
            return result;
        }
    };

    return descriptor;
}


/**
 * Usage:
 *  * import the decorator method into the class - <i>import { executionSetterTime } from "@goodgamestudios/createjs-utilities";</i>
 *  * add decorator to the wished setter - <i>@executionSetterTime</i>
 *  <b> The used classes by setter must be imported in advance </b>
 * @param target
 * @param {string} propertyKey
 * @param {PropertyDescriptor} descriptor
 * @returns {PropertyDescriptor}
 */
function executionSetterTime(target: any, propertyKey: string, descriptor: PropertyDescriptor) {

    if(descriptor === undefined) {
        descriptor = Object.getOwnPropertyDescriptor(target, propertyKey) as PropertyDescriptor;
    }
    var set = descriptor.set;

    if (set){
        descriptor.set = function (value) {
            console.log(`Performance - Setter: %c${propertyKey}%c scope:`, "color: blue;", "color: black;");
            let timeStamp = performance.now();
            if(set !== undefined){
                set.apply(this, [value]);
            }
            let endTimeStamp = performance.now() - timeStamp;
            let durationIndicatorColor = endTimeStamp > EXECUTION_THRESHOLD ? "red" : "green" ;

            let averageTimeForMethod = addExecutedMethod(target, propertyKey, endTimeStamp);
            console.log(`Performance - Setter: %c${propertyKey}%c took - %c${endTimeStamp} %cms [Average time: %c${averageTimeForMethod} %cms]`, "color: blue;", "color: black;", `color: ${durationIndicatorColor};`, "color: black;",`color: ${durationIndicatorColor};`, "color: black;");
        }
    };

    return descriptor;
}

export { executionMethodTime };
export { executionGetterTime };
export { executionSetterTime };

function addExecutedMethod(target: any, methodName: string, duration: number): number {
    let result = 0;
    if(averageTimePerMethod.has(target)){
        let targetMethodsList = averageTimePerMethod.get(target)
        let timeDelay = duration;
        if(targetMethodsList.has(methodName)){
            timeDelay = (targetMethodsList.get(methodName) + duration) / 2
        }
        targetMethodsList.set(methodName, timeDelay);
    }else{
        averageTimePerMethod.set(target, new Map().set(methodName, duration));
    }
    return averageTimePerMethod.get(target).get(methodName);
}
